import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TAuditEvent } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetAuditedEventsToSupervise = async ({
  isAuditingPerformance,
  adminId,
  dateMin,
  dateMax,
  issueType,
  eventType,
  subscription,
  gender,
  actionTaken,
  limit
}: {
  isAuditingPerformance: boolean;
  adminId: number;
  dateMin: Date;
  dateMax: Date;
  eventType: string;
  issueType: string;
  subscription: string;
  gender: string;
  actionTaken: string;
  limit: number;
}): Promise<{
  data: TAuditEvent[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TAuditEvent[]>(
    `supervisor/getAuditedEventsToSupervise`,
    {
      isAuditingPerformance,
      adminId,
      issueType,
      eventType,
      subscription,
      gender,
      actionTaken,
      startDateObject: getDateAsObject(dateMin),
      endDateObject: getDateAsObject(dateMax),
      limit
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
